export enum StrategyAssetCategoryTypeEnum {
  'USER' = 'USER',
  'SYSTEM' = 'SYSTEM',
}
